"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductHeaderLogo = function ProductHeaderLogo(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    smDown: true
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: "logo"
  }, children));
};

var _default = ProductHeaderLogo;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0hlYWRlci9Qcm9kdWN0SGVhZGVyL1Byb2R1Y3RIZWFkZXJMb2dvLnRzeCJdLCJuYW1lcyI6WyJQcm9kdWN0SGVhZGVyTG9nbyIsImNoaWxkcmVuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7Ozs7O0FBR0EsSUFBTUEsaUJBQTJCLEdBQUcsU0FBOUJBLGlCQUE4QjtBQUFBLE1BQUdDLFFBQUgsUUFBR0EsUUFBSDtBQUFBLHNCQUNsQyw2QkFBQyxlQUFEO0FBQVEsSUFBQSxNQUFNO0FBQWQsa0JBQ0UsNkJBQUMsWUFBRDtBQUFLLElBQUEsU0FBUyxFQUFDO0FBQWYsS0FBdUJBLFFBQXZCLENBREYsQ0FEa0M7QUFBQSxDQUFwQzs7ZUFNZUQsaUIiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsgSGlkZGVuLCBCb3ggfSBmcm9tICdAbWF0ZXJpYWwtdWkvY29yZSc7XG5cbmNvbnN0IFByb2R1Y3RIZWFkZXJMb2dvOiBSZWFjdC5GQyA9ICh7IGNoaWxkcmVuIH0pID0+IChcbiAgPEhpZGRlbiBzbURvd24+XG4gICAgPEJveCBjbGFzc05hbWU9XCJsb2dvXCI+e2NoaWxkcmVufTwvQm94PlxuICA8L0hpZGRlbj5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFByb2R1Y3RIZWFkZXJMb2dvO1xuIl19